import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import React,{useState,useEffect} from "react";
// Core viewer
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


function ViewPDF({ close }) {
  const fileUrl=close.host && close.attachment && close.token? close.host+close.attachment+close.token: "http://localhost:5000/assets/document/Request/Attachments/5c045e2d-8944-44a6-a492-edabbafceab0.pdf?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGFmZl9pZCI6IjEyMyIsImRlcCI6IjEyMyIsImxldmVsIjpbMTAwMCwxMDAxLDEwMDIsMTAxLDEwMiwxMDMsMTA0LDEwNSwxMDYsMTA3LDEwOCwxMDksMTEwLDExMDAsMTEwMSwxMTAyLDExMDMsMTExLDExMiwxMTMsMTE0LDExNSwyMDAsMjAxLDIwMiwyMDMsMjA0LDIwNSwzMDEsMzAyLDMwMywzMDQsMzA1LDMwNiwzNTAsMzUxLDM1MiwzNTMsMzU0LDM1NSw0MDAsNDAxLDQwMiw0MDQsNDA1LDQwNiw0MDcsNDA4LDQwOSw0MTAsNDUwLDQ1MSw0NTIsNTAwLDUwMSw1MDIsNTAzLDYwMCw2MDEsNjAyLDcwMCw3NTAsODAxLDgwMiw4MDMsODA0LDgwNSw5MDBdLCJvZmZpY2VfaWQiOiIxMjMiLCJpYXQiOjE2NjcyMjIxMzIsImV4cCI6MTY2NzIyMzkzMn0.vr4jAKUMbnpuTdBsVYnpspP9AMUVC1HAL94m0ZsLJBY"
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  // console.log(close.host, close.attachment, close.token);
 
  return (
      <Box sx={{ width: "80%", height: "90%",  }}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js">
        <Viewer
        fileUrl={fileUrl}
        plugins={[
            defaultLayoutPluginInstance,
        ]}
        ></Viewer>
        </Worker>
      </Box>
  );
}

export default ViewPDF;
